export const ActionType = {
  SAVE: "save",
  NEXT: "next",
  ACTIVATE: "activate",
  FETCH: "fetch",
  COLLAPSE: "collapse",
} as const;
export type ActionType = typeof ActionType[keyof typeof ActionType];